const SteelGableHobbyParts = (nodes, materials, metal, type, verticalPosition, leftRotate, rightRotate) => {
  let partsToShow = []

  partsToShow.push(
    <group key="steel-gable-hobby-parts" >
      <mesh name="MOVE_VERTICAL" geometry={nodes.MOVE_VERTICAL.geometry} material={materials['Material_0.019']} position={[-0.6, verticalPosition, 0.013]}>
        {metal}
        <mesh name="32mm_Brace_Bracket012" geometry={nodes['32mm_Brace_Bracket012'].geometry} material={materials['Material_0.018']} position={[-0.6, -0.02, -0.015]} >
          {metal}
        </mesh>
        <mesh name="32mm_Brace_Bracket013" geometry={nodes['32mm_Brace_Bracket013'].geometry} material={materials['Material_0.018']} position={[0.602, 0.004, -0.015]} rotation={[0, 0, Math.PI]} >
          {metal}
        </mesh>
        <mesh name="Mesh_1017" geometry={nodes.Mesh_1017.geometry} material={materials['Material_1.008']} position={[-0.568, -0.008, -0.012]} rotation={[0, 0.052, -1.351]} >
          {metal}
        </mesh>
        <mesh name="Mesh_1018" geometry={nodes.Mesh_1018.geometry} material={materials['Material_1.008']} position={[0.57, -0.008, -0.012]} rotation={[0, -0.052, 1.791]} >
          {metal}
        </mesh>
        <mesh name="Mesh_2017" geometry={nodes.Mesh_2017.geometry} material={materials.Material_2} position={[-0.568, -0.008, -0.012]} rotation={[0, 0.052, -1.351]} >
          {metal}
        </mesh>
        <mesh name="Mesh_2018" geometry={nodes.Mesh_2018.geometry} material={materials.Material_2} position={[0.57, -0.008, -0.012]} rotation={[0, -0.052, 1.791]} >
          {metal}
        </mesh>
        <mesh name="Mesh_3017" geometry={nodes.Mesh_3017.geometry} material={materials.Material_3} position={[-0.571, -0.015, -0.022]} rotation={[Math.PI, -0.052, 2.979]} >
          {metal}
        </mesh>
        <mesh name="Mesh_3018" geometry={nodes.Mesh_3018.geometry} material={materials.Material_3} position={[0.573, -0.001, -0.022]} rotation={[-Math.PI, 0.052, -0.162]} >
          {metal}
        </mesh>
        <mesh name="Mesh_4019" geometry={nodes.Mesh_4019.geometry} material={materials.Material_2} position={[-0.571, -0.015, -0.022]} rotation={[Math.PI, -0.052, 2.979]} >
          {metal}
        </mesh>
        <mesh name="Mesh_4020" geometry={nodes.Mesh_4020.geometry} material={materials.Material_2} position={[0.573, -0.001, -0.022]} rotation={[-Math.PI, 0.052, -0.162]} >
          {metal}
        </mesh>
      </mesh>
      <mesh name="ROTATE" geometry={nodes.ROTATE.geometry} material={materials['Material_0.018']} position={[0.001, -0.014, 0.001]} rotation={[0, 0, leftRotate]}>
        {metal}
        <mesh name="Mesh_1016" geometry={nodes.Mesh_1016.geometry} material={materials['Material_1.008']} rotation={[0, 0.052, -1.351]} >
          {metal}
        </mesh>
        <mesh name="Mesh_2016" geometry={nodes.Mesh_2016.geometry} material={materials.Material_2} rotation={[0, 0.052, -1.351]} >
          {metal}
        </mesh>
        <mesh name="Mesh_3016" geometry={nodes.Mesh_3016.geometry} material={materials.Material_3} position={[-0.003, -0.007, -0.01]} rotation={[-Math.PI, -0.052, 2.979]} >
          {metal}
        </mesh>
        <mesh name="Mesh_4018" geometry={nodes.Mesh_4018.geometry} material={materials.Material_2} position={[-0.003, -0.007, -0.01]} rotation={[-Math.PI, -0.052, 2.979]} >
          {metal}
        </mesh>
      </mesh>
      <mesh name="STEEL_GABLE_R32001" geometry={nodes.STEEL_GABLE_R32001.geometry} material={materials['Material_0.014']} position={[-1.2, -0.009, 0]}>
        {metal}
        <mesh name="ROTATE001" geometry={nodes.ROTATE001.geometry} material={materials['Material_0.018']} position={[0, -0.015, 0.001]} rotation={[0, 0, rightRotate]}>
          {metal}
          <mesh name="Mesh_1" geometry={nodes.Mesh_1.geometry} material={materials['Material_1.008']} rotation={[0, 0.052, -1.351]} >
            {metal}
          </mesh>
          <mesh name="Mesh_2" geometry={nodes.Mesh_2.geometry} material={materials.Material_2} rotation={[0, 0.052, -1.351]} >
            {metal}
          </mesh>
          <mesh name="Mesh_3" geometry={nodes.Mesh_3.geometry} material={materials.Material_3} position={[-0.003, -0.007, -0.01]} rotation={[Math.PI, -0.052, 2.979]} >
            {metal}
          </mesh>
          <mesh name="Mesh_4" geometry={nodes.Mesh_4.geometry} material={materials.Material_2} position={[-0.003, -0.007, -0.01]} rotation={[Math.PI, -0.052, 2.979]} >
            {metal}
          </mesh>
        </mesh>
      </mesh>
    </group>
  )

  return partsToShow
}

export default SteelGableHobbyParts